// Chromeless routes: still authenticated, but rendered without the app
// shell (nav sidebar, devbar).
const EMBED_ROUTE_PATTERNS = [/^\/recordings\/[^/]+\/embed$/];

export const isEmbedRoute = (pathname: string): boolean =>
  EMBED_ROUTE_PATTERNS.some(pattern => pattern.test(pathname));
